module.exports = __webpack_public_path__ + "img/gestion_comercial.6746f396.jpeg";